'use client';

import { authClient } from '@/lib/auth-client';
import { useEffect } from 'react';

interface AutoLoginProps {
  provider: string;
  callbackUrl: string;
}

export default function AutoLogin({ provider, callbackUrl }: AutoLoginProps) {
  useEffect(() => {
    authClient.signIn
      .oauth2({
        providerId: provider,
        callbackURL: callbackUrl,
      })
      .catch((err) => {
        console.error('[AutoLogin] sign-in error', err);
      });
  }, [provider, callbackUrl]);

  return <></>;
}
